import axios from 'axios';

const createUserSettingsApiInstance = () => {
  const baseURL =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
      ? 'http://localhost:10000/api3.2/user/settings'
      : '/api3.2/user/settings';

  return axios.create({ baseURL, withCredentials: true });
};

const userSettingsApi = createUserSettingsApiInstance();

export default userSettingsApi;
